"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _Utils = require("./Utils.js");

var _DateFormatter = require("./DateFormatter.js");

var _NumberFormatter = require("./NumberFormatter.js");

var _aApplicationData = require("./aApplicationData.js");

var _reactJsonView = require("react-json-view");

var jquery = require("jquery");

/**
 * @class
 * @classdesc UI Utils <br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.UiUtils.[methodName] <br/>
 * @constructor
 */
function UiUtils() {}
/**
 * 
 * @param {*} col 
 * @param {*} amt 
 */


UiUtils.prototype.LightenDarkenColor = function (col, amt) {
  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;else if (r < 0) r = 0;
  var b = (num >> 8 & 0x00FF) + amt;
  if (b > 255) b = 255;else if (b < 0) b = 0;
  var g = (num & 0x0000FF) + amt;
  if (g > 255) g = 255;else if (g < 0) g = 0;
  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.isNil = function (text) {
  return text === null || text === undefined || text === "";
};
/**
 * 
 * @param {*} text 
 * @param {*} deftxt 
 */


UiUtils.prototype.text = function (text, deftxt) {
  if (UiUtils.isNil(text)) return deftxt || "";
  return text;
};
/**
 * 
 * @param {*} obj 
 */


UiUtils.prototype.renderJson = function (obj) {
  var cfg = {
    theme: "rjv-default",
    iconStyle: "triangle",
    collapsed: 1,
    enableClipboard: true,
    displayDataTypes: false,
    collapseStringsAfterLength: 30,
    groupArraysAfterLength: 50,
    onEdit: false,
    onDelete: false,
    onAdd: false
  };
  return (0, _react.createElement)(_reactJsonView.default, {
    src: obj
  }, cfg);
};
/**
 * 
 * @param {*} icon 
 */


UiUtils.prototype.icon = function (icon) {
  if (!icon) return null;
  if (icon.indexOf("fa ") < 0 && icon.indexOf(" fa ") < 0) icon = "fa " + icon;
  return /*#__PURE__*/React.createElement("i", {
    className: icon,
    "aria-hidden": true
  });
};
/**
 * 
 * @param {*} text 
 * @param {*} deftxt 
 */


UiUtils.prototype.yesno = function (text, deftxt) {
  if (text === undefined || text === null) return deftxt;
  var b;

  if (text instanceof Boolean) {
    b = text;
  } else {
    text = "" + text;
    text = text.toLowerCase();
    b = text === 'true' || text === 'yes' || text === 'ok' || text === '1' || text === '-1';
  }

  return b ? 'yes' : 'no';
};
/**
 * 
 */


UiUtils.prototype.texts = function () {
  if (arguments.length < 2) return "";
  var deftxt = arguments[0];
  var separator = arguments[1];
  var res = "";
  var sep = "";
  var some = false;

  for (var i = 2; i < arguments.length; i++) {
    var r = arguments[i];
    if (!r) continue;
    var sr = "" + r;
    sr = sr.trim();
    if (sr === "") continue;
    some = true;
    res += sep + sr;
    sep = separator;
  }

  if (some) return res;else return deftxt;
};
/**
 * @returns {String} the default currency wich is taken from AP_OPZIONI  with values opt("GLOBALE", "DIVRIF"). If there is no such Opzione "HRK" is returned instead
 */


UiUtils.prototype.defaultCurrency = function () {
  var divrif = (0, _aApplicationData.opt)("GLOBALE", "DIVRIF");
  if (divrif) return divrif;
  return "HRK";
};
/**
 * @returns {String} the default language wich is "IT"
 */


UiUtils.prototype.defaultLang = function () {
  return "IT";
};
/**
 * @returns {Stirng} The default locale from the number formatter
 */


UiUtils.prototype.defaultLocale = function () {
  var defaultLocale = _NumberFormatter.default.getDefaultLocale(); //console.warn("!!! USATO UN FORMATTATORE DI UIUTILS .... SPOSTARSI SU NUMBERFORMATTER -  default locale: " + defaultLocale);


  return defaultLocale;
};
/**
 * 
 * @param {*} val 
 * @param {*} currency 
 * @param {*} defVal 
 */


UiUtils.prototype.money = function (val, currency, defVal) {
  if (val === null || val === undefined) {
    return defVal;
  }

  if (!currency) currency = this.defaultCurrency();
  return _NumberFormatter.default.format(val, this.defaultLocale()) + " " + currency;
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.number4 = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.format4FractionDigits(val, this.defaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.number = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.format(val, this.defaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.numberInt = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.formatInt(val, this.defaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} numDigits 
 * @param {*} defVal 
 */


UiUtils.prototype.numberDigits = function (val, numDigits, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.formatDigits(val, numDigits, this.defaultLocale());
};
/**
 * 
 */


UiUtils.prototype.translate = function () {
  var args = arguments;
  if (!args || args.length < 3 || args.length % 2 === 0) throw new Error("invalid arguments for UiUtils.translate(). example: .translate(val, 'val1', 'Valore 1', 'val2', 'Valore 2'...)");
  var v = args[0];
  if (v === undefined || v === null) return "";
  var value = "" + v;

  for (var i = 1; i < args.length; i += 2) {
    var val = "" + args[i];
    if (val === val) return "" + args[i + 1];
  }

  return value;
};
/**
 * 
 * @param {*} val 
 */


UiUtils.prototype.sign = function (val) {
  if (val === null || val === undefined || isNaN(val) || val === 0) {
    return "";
  }

  if (val > 0) return "+";else return "-";
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.perc = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.intPercent(val, this.defaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.decimalPerc = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return _NumberFormatter.default.percent(val, this.defaultLocale());
};
/**
 * 
 * @param {*} email 
 * @param {*} defNoEmail 
 * @param {*} className 
 */


UiUtils.prototype.email = function (email, defNoEmail, className) {
  if (!email) return defNoEmail || "";
  return /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + email,
    className: 'email ' + (className ? className : '')
  }, email);
};
/**
 * 
 * @param {*} tel 
 * @param {*} defNoTel 
 * @param {*} className 
 */


UiUtils.prototype.tel = function (tel, defNoTel, className) {
  if (!tel) return defNoTel || "";
  return /*#__PURE__*/React.createElement("a", {
    href: 'tel:' + tel,
    className: 'phone ' + (className ? className : '')
  }, tel);
};
/**
 * 
 * @param {*} dt 
 * @param {*} defDt 
 */


UiUtils.prototype.date = function (dt, defDt) {
  return _DateFormatter.default.dataFormatterShort(dt, defDt, this.defaultLocale());
};
/**
 * 
 * @param {*} codDominio 
 * @param {*} trascVal 
 */


UiUtils.prototype.domainByTrascVal = function (codDominio, trascVal) {
  var dd = (0, _aApplicationData.domain)(codDominio);
  var ret = null;
  if (!dd) return ret;
  dd.forEach(function (dom, index) {
    if (!ret && dom.trascVal === trascVal) {
      ret = dom;
    }
  });
  return ret;
};
/**
 * 
 * @param {*} dom 
 * @param {*} trascVal 
 * @param {*} defVal 
 */


UiUtils.prototype.labelDomainTrascVal = function (dom, trascVal, defVal) {
  var d = this.domainByTrascVal(dom, trascVal);
  if (!d) return defVal || "";
  return d.desDom;
};
/**
 * 
 * @param {*} dom 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.labelDomain = function (dom, val, defVal) {
  var d = (0, _aApplicationData.domainVal)(dom, val);
  if (!d) return defVal || "";
  return d.desDom;
};
/**
 * 
 * @param {*} dom 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.colorDomain = function (dom, val, defVal) {
  var d = (0, _aApplicationData.domainVal)(dom, val);
  if (!d) return defVal || "";
  return d.trascVal;
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.slugify = function (text) {
  if (text === null || text === undefined) return "";
  return text.toString().toLowerCase().replace(/[\s\-\_\/]+/g, '-') // Replace spaces and separators with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.clean = function (text) {
  if (text === null || text === undefined) return "";
  return text.toString().toLowerCase().replace(/[\s\-\_\/]+/g, '_') // Replace spaces and separators with -
  .replace(/[^\w\_]+/g, '') // Remove all non-word chars
  .replace(/\_\_+/g, '_') // Replace multiple _ with single _
  .replace(/^_+/, '') // Trim _ from start of text
  .replace(/_+$/, ''); // Trim _ from end of text
};
/**
 * 
 * @param {*} elem 
 * @param {*} offset 
 * @param {*} completeFunc 
 * @param {*} duration 
 */


UiUtils.prototype.scrollTo = function (elem, offset, completeFunc, duration) {
  var container = jquery('body');
  var scrollTo = jquery(elem);
  if (scrollTo.length === 0) return;
  var pos = scrollTo.offset().top - (offset || 0);
  container.animate({
    scrollTop: pos - container.offset().top
  }, {
    duration: duration || 500,
    // easing: "easein",
    complete: completeFunc
  });
};
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */


UiUtils.prototype.detectIE = function () {
  var ua = window.navigator.userAgent; // Test values; Uncomment to check result …
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return 0;
};
/**
 * 
 * @param {*} elem 
 */


UiUtils.prototype.getCursorPosition = function (elem) {
  // Initialize
  var iCaretPos = null; // IE Support

  if (elem.selection) {
    input.focus();
    var sel = document.selection.createRange();
    var selLen = document.selection.createRange().text.length;
    sel.moveStart('character', -input.value.length);
    iCaretPos = sel.text.length - selLen;
  } // Chrome/Firefox support
  else if (elem.selectionStart || elem.selectionStart === '0') {
      iCaretPos = elem.selectionStart;

      if (this.detectIE() >= 11) {// IE11 => fa l'inverso??? no
        // iCaretPos = elem.value.length - elem.selectionStart;
      }
    } // Return results


  return iCaretPos;
};
/**
 * 
 * @param {*} elem 
 * @param {*} cursorPos 
 */


UiUtils.prototype.setCursorPosition = function (elem, cursorPos) {
  if (!elem || cursorPos === null || cursorPos === undefined || cursorPos < 0) return;

  if (elem.createTextRange) {
    if (elem.style.textAlign === 'right') {
      cursorPos = elem.value.length - cursorPos; //cursorPos = -cursorPos;
    }

    var range = elem.createTextRange();
    range.move('character', cursorPos);
    range.select();
  } else if (elem.selectionStart) {
    elem.focus();

    if (elem.style.textAlign === 'right') {
      cursorPos = elem.value.length - cursorPos;
    }

    elem.setSelectionRange(cursorPos, cursorPos);
  } else elem.focus();
};
/**
 * private.
 * assume if not null, a and b are the same type.
 * @param {*} a 
 * @param {*} b 
 */


UiUtils.prototype.builtinComparator = function (a, b) {
  if (a === undefined) a = null;
  if (b === undefined) b = null;
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1; // check on type date

  if (a instanceof Date) {
    var dateA = a.getTime();
    var dateB = b.getTime();
    return dateA < dateB ? -1 : dateA === dateB ? 0 : -1;
  } // any not number


  if (isNaN(a)) {
    var aa = a.toString().toLowerCase();
    var bb = b.toString().toLowerCase();
    return aa.localeCompare(bb);
  }

  if (a < b) return -1;
  if (a === b) return 0;
  return 1;
};
/**
 * 
 * @param {*} val 
 * @param {*} numZero 
 */


UiUtils.prototype.zeroFill = function (val, numZero) {
  var zeroToAdd = numZero;
  var strVal = "";
  if (val !== null && val !== undefined) strVal = "" + val;
  var res = "";
  zeroToAdd -= strVal.length;

  for (var i = 0; i < zeroToAdd; i++) {
    res += "0";
  }

  res += strVal;
  return res;
};

var exp = new UiUtils();
var _default = exp;
exports.default = _default;